import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {setName, setEmail, setAddress, setMemberFieldError } from '../actions/member';

import Customer from '../components/Customer';
import ContainerProps from './MemberInfoContainerComponent';
import { getKioskOptions } from '../../../selectors/ui';
import { initKeyboard } from 'checkout/actions/keyboard';
import { getAllAvailableDeliveryOptions, getSelectedDeliveryMethodType } from '../../../selectors/delivery';
import { DELIVERY_TYPE_EMAIL } from '../../delivery/reducers/delivery';
import Translation from "../../../../shared/Translation";

class MemberInfoContainer extends Component<ContainerProps> {
    render() {
        let showName = true;
        let showEmail = true;
        let nameRequired = true;
        let emailRequired = true;
        let emailIsOnlyOption = this.props.allDeliveryOptions.length === 1 && +this.props.allDeliveryOptions[0].method_type === DELIVERY_TYPE_EMAIL;

        //in kiosk mode, seller can configure whether to capture name or email and whether each is required
        if (this.props.isKiosk) {
            showName = this.props.kioskOptions.collectCustomerName ? true : false;
            showEmail = this.props.kioskOptions.collectCustomerEmail ? true : false;
            nameRequired = this.props.kioskOptions.customerNameRequired ? true : false;
            emailRequired = this.props.kioskOptions.customerEmailRequired || emailIsOnlyOption || (this.props.selectedDeliveryMethodType === DELIVERY_TYPE_EMAIL && this.props.kioskOptions.collectCustomerEmail && !this.props.kioskOptions.customerEmailRequired) ? true : false;
        }

        return(
            <Fragment>
                {this.props.isKiosk &&
                    <h4 className="checkout-form__sub-heading"><Translation>{"checkout__register"}</Translation></h4>
                }
                <Customer
                    name={this.props.name}
                    showName={showName}
                    nameRequired={nameRequired}
                    onNameChange={this.onNameChange}
                    email={this.props.email}
                    showEmail={showEmail}
                    emailRequired={emailRequired}
                    onEmailChange={this.onEmailChange}
                    showPhone={false}
                    onNameFocus={this.onNameFocus}
                    onEmailFocus={this.onEmailFocus}
                />
            </Fragment>
        )
    }

    onNameFocus = (e, label) => {
        this.props.initKeyboard(e.target, label, setName, "name");
        this.props.setMemberFieldError('name', undefined);
    }

    onEmailFocus = (e, label) => {
        this.props.initKeyboard(e.target, label, setEmail, "email");
        this.props.setMemberFieldError('email', undefined);
    }

    onNameChange = (e) => {
        this.props.setName(e.target.value);
    }

    onEmailChange = (e) => {
        this.props.setEmail(e.target.value);
    }
}

const mapStateToProps = (state) => {
    return {
        name: state.member.name,
        email: state.member.email,
        isKiosk: state.ui && state.ui.uiConfig && state.ui.uiConfig.layout === "kiosk",
        kioskOptions: getKioskOptions(state),
        allDeliveryOptions: getAllAvailableDeliveryOptions(state),
        selectedDeliveryMethodType: getSelectedDeliveryMethodType(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setName,
        setEmail,
        setAddress,
        initKeyboard,
        setMemberFieldError
    }, dispatch);
}

MemberInfoContainer.propTypes = {
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberInfoContainer)
